import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener("DOMContentLoaded", function() {

  // window.addEventListener("load", function() {

    (function ($) {

      const blocks = document.querySelectorAll(".block__hkbis-get-to-know-slider");

      blocks.forEach(block => {

        const post_id = block.dataset.postid;
        const block_id = block.dataset.blockid;

        if (block !== undefined) {

          const getToKnowContent = block.querySelector(".hkbis-get-to-know-slider-animation");

          if (getToKnowContent) {

            jQuery('html').css('scroll-behavior', 'auto');

            let lastSlider = 0;
            let endIndex = 0;

            let timeline = null;

            const numberOfSlides = parseInt(getToKnowContent.dataset.numberofslides);
            const blockID = getToKnowContent.querySelector(".block__hkbis-get-to-know-slider--block-id").id;

            const navLinks = getToKnowContent.querySelectorAll('.block__hkbis-get-to-know-slider__nav-container__slider-container a');
            const mobileNavSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-get-to-know-slider__nav-container__slider-container.slider');
            const contentSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-get-to-know-slider__content-container.slider');

            const nextButton = getToKnowContent.querySelector('.slick-next');
            const prevButton = getToKnowContent.querySelector('.slick-prev');

            const contentSlides = [...getToKnowContent.querySelectorAll('.block__hkbis-get-to-know-slider__content-container > .slick-list > .slick-track > .slick-slide')];
            const contentSliderSlickTrack = getToKnowContent.querySelector('.block__hkbis-get-to-know-slider__content-container > .slick-list > .slick-track');

            let teamSliders = null;
            let innerSliders = null;

            // const indicatorMobile = document.querySelector('#' + blockID.toString() + ' .slide-indicator-mobile--indicator');
            const indicatorDesktop = document.querySelector('#' + blockID.toString() + ' .slide-indicator-desktop--indicator');

            endIndex = [...navLinks].length - 1;

            const initSlicks = (element) => {
              let slickElement = $(element);
              slickElement.slick();
              // slickElement.find('.slider').slick();

              // ---- prevent click when dragging on modals inside slick with custom attr ----
              const clickElements = slickElement.find('button[data-bs-target-custom]');
              clickElements.each(function() {
                $(this).removeAttr('data-bs-toggle')
              });

              const delta = 2;
              let startX;
              let startY;

              clickElements.on('mousedown', function (event) {
                startX = event.pageX;
                startY = event.pageY;
              });

              clickElements.on('mouseup', function (event) {
                const diffX = Math.abs(event.pageX - startX);
                const diffY = Math.abs(event.pageY - startY);
                const $this = $(this);

                if (diffX < delta && diffY < delta) {
                  const target = $($this.attr('data-bs-target-custom'));
                  if ($this.attr('data-bs-target-custom-index')) {
                    const index = parseInt($this.attr('data-bs-target-custom-index'));
                    target.find('.slider').slick('slickGoTo', index);
                  }
                  target.modal('show');
                }
              });

              clickElements.mousedown(function(e){
                  $(document).mousemove(function(){})
              }).mouseup(function(){
                  $(document).unbind('mousemove')
              })
              // ---- prevent click when dragging on modals inside slick with custom attr end ----
            }

            const resizeVerticalSlider = () => {
              let minHeight = 0;
              contentSliderSlickTrack.style.minHeight = 'unset';
              contentSlides.forEach(slide => {
                slide.style.minHeight = 'unset';
                const currentHeight = slide.getBoundingClientRect().height;
                if (currentHeight >= minHeight) {
                  minHeight = currentHeight;
                }
              });
              contentSlides.forEach(slide => {
                slide.style.minHeight = minHeight.toString() + 'px';
              });
              contentSliderSlickTrack.style.minHeight = (minHeight * 3).toString() + 'px';
            }

            const setActiveMenu = (index) => {
              [...navLinks].forEach(link => {
                link.classList.remove(['active']);
              })
              navLinks[index].classList.add(['active']);
            }

            const moveIndicators = (index, lastSlider, numberOfSlides) => {
              // gsap.to(indicatorMobile,  {left: (1 / numberOfSlides * 100 * index).toString() + '%'});
              if (lastSlider > index) {
                gsap.to(indicatorDesktop, {top: navLinks[index].parentNode.offsetTop +8});
              } else if (lastSlider < index) {
                gsap.to(indicatorDesktop, {top: navLinks[index].parentNode.offsetTop -10});
              }
            }

            const moveSliders = (index) => {

              if (index < 0) {
                index = endIndex;
              }
              if (index > endIndex) {
                index = 0;
              }

              setActiveMenu(index);
              moveIndicators(index, lastSlider, numberOfSlides);
              if(document.readyState === "complete") {
                if(window.innerWidth < 992 && mobileNavSlider){
                  mobileNavSlider.slick('slickGoTo', index);
                }
                contentSlider.slick('slickGoTo', index);
                let teamSlider = contentSlides[index]?.querySelector('.block__hkbis-get-to-know-slider__content-container__slide__type-team');
                if (teamSlider) {
                  teamSlider = jQuery(teamSlider);
                  if (teamSlider) {
                    teamSlider.slick('slickPlay');
                  }
                }
              }
              lastSlider = index;
            }

            const initsAfterAjax = (timeline) => {
              innerSliders = jQuery('#' + blockID.toString() + ' .inner-slider');
              teamSliders = jQuery('#' + blockID.toString() + ' .block__hkbis-get-to-know-slider__content-container__slide__type-team.slider');

              innerSliders.each(function() {
                jQuery(this).on('mousedown touchstart', function(){
                  contentSlider.slick('setOption', {
                    swipe: false
                  });
                });
              });

              timeline?.scrollTrigger.refresh();
              resizeVerticalSlider();
            }

            // --------------------------------------------------------
            // --------------------------------------------------------

            resizeVerticalSlider();
            window.addEventListener('resize', function() {
              resizeVerticalSlider();
            });

            navLinks[0].classList.add(['active']);
            gsap.to(indicatorDesktop, {top: navLinks[0].parentNode.offsetTop +8});

            ScrollTrigger.matchMedia({
              "(min-width: 992px)": function () {
                timeline = gsap.timeline({
                  scrollTrigger: {
                    trigger: getToKnowContent,
                    pin: getToKnowContent,
                    pinSpacing: false,
                    anticipatePin: 1,
                    scrub: 1,
                    start: "center center",
                    end: "+=3000",
                    ease: "none",
                    toggleClass: 'pinned'
                  },
                  ease: "none",
                });

                timeline.duration(1000);

                for (let i = 0; i < numberOfSlides; i++) {
                  timeline.add( ["slide-" + i.toString(), gsap.delayedCall(100, moveSliders, [i])]);
                }
                timeline.add( ["end", gsap.delayedCall(100, undefined, null)] );

                const resizeObserver = new ResizeObserver(function() {
                  if (timeline?.scrollTrigger) {
                    timeline.scrollTrigger.refresh()
                  }
                });
                resizeObserver.observe(document.body)
              },
            });

            [...navLinks].forEach(link => {
              link.addEventListener('click', function() {
                const index = link.dataset.index;
                moveSliders(index);
              });
            });

            nextButton.addEventListener('click', function(e){
              moveSliders(lastSlider + 1);
            });

            prevButton.addEventListener('click', function(e){
              moveSliders(lastSlider - 1);
            });

            if (mobileNavSlider) {
              mobileNavSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                moveSliders(nextSlide);
              });
            }

            // contentSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //   if(window.innerWidth < 992){
            //     moveSliders(nextSlide);
            //   }
            // });

            let ajaxTrigger = gsap.timeline({
              scrollTrigger: {
                trigger: getToKnowContent,
                start: 'top-=1000 bottom',
                onEnter: () => {
                  console.log('load get-to-know inner sliders');
                  $.ajax({
                    type: 'post',
                    url: ajaxurl,
                    data: {action: 'hkbis_ajax_block_call', data: {post_id, block_id}},
                    success: (response) => {
                      const parser = new DOMParser();
                        const html = parser.parseFromString(response, 'text/html');

                        const innerSliders = [...html.querySelectorAll('.ajax-slider-container')];
                        innerSliders.forEach(slider => {
                          const parentElementSelector = slider.dataset.parent;
                          if (parentElementSelector) {
                            const parent = getToKnowContent.querySelector(parentElementSelector);
                            if (parent) {
                              parent.innerHTML = slider.innerHTML;
                              initSlicks(parent);
                            }
                          }
                        })
                        initsAfterAjax(timeline);
                    },
                    error: function (error) {
                      console.log("Error:", error);
                    }
                  });
                },
                once: true,
              },
            });
          }
        }
      });
    })(jQuery);
  // });
});



